import { Controller } from "@hotwired/stimulus";

const PER_ENROLLED = "per_enrolled_student_with_lessons";
const WITH_MINIMUM = "with_lessons_or_tests_with_minimum";
const INITIAL_PURCHASE = "per_student_with_initial_purchase_amount";

export default class extends Controller {
  static targets = ["strategySelect", "perEnrolledPanel", "withMinimumPanel", "initialPurchasePanel"];

  connect() {
    this.refresh();
  }

  refresh() {
    const v = this.strategySelectTarget.value;
    this.perEnrolledPanelTarget.classList.toggle("u-hidden", v !== PER_ENROLLED);
    this.withMinimumPanelTarget.classList.toggle("u-hidden", v !== WITH_MINIMUM);
    this.initialPurchasePanelTarget.classList.toggle("u-hidden", v !== INITIAL_PURCHASE);
  }
}
